export const modules = {
  Home: "HOME",
  Calendar: "CALENDAR",
  Tracking: "TRACKING",
  Contacts: "CONTACTS",
  Forbidden: "FORBIDDEN"
} as const

export const contentPath = {
  [modules.Home]: "/home",
  [modules.Calendar]: "/calendar",
  [modules.Tracking]: "/tracking",
  [modules.Contacts]: "/contacts",
  [modules.Forbidden]: "/sorry"
} as const
